import React from 'react';
import {Helmet} from 'react-helmet';

const TitleComponent = ({ title }) => {
    var defaultTitle = 'W-Hub – платформа для создания онлайн школы.';
    return (
        <Helmet>
            <title>{title ? title : defaultTitle}</title>
        </Helmet>
    );
};

export { TitleComponent };